import {useNavigate} from "react-router-dom";
import SnackError from "../../components/SnackError";
import React from "react";
import {usePostMachineMutation} from "./machine_api";
import MachineForm from "./MachineForm";
import {Card, CardContent} from "@mui/material";
import Title from "../navigation/Title";
import {TablesInsert} from "../../apitypes";
import {useGetOperationQuery} from "../operation/operation_api";


export const MachineCreate = () => {

    const [post, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePostMachineMutation();
    const {data: workTasks} = useGetOperationQuery({})
    const navigate = useNavigate();
    const handleSubmit = async function (values: TablesInsert<"machine"> & { workTask?: TablesInsert<"workTask"> }) {
        const {workTask, ...machine} = values
        if (workTask) {
            machine.DefaultOperationID = workTask.id
        }
        const resp = await post(machine)
        if ("data" in resp) {
            navigate("..")
        }
    };

    return <>
        <Title title={"Nov stroj"}/>
        <Card sx={{mt: "2em"}}>
            {isError && <SnackError error={error}/>}
            <CardContent>
                <MachineForm
                    isUpdating={isUpdating}
                    // @ts-ignore
                    onSubmit={handleSubmit}
                    workTasks={workTasks}
                    onCancel={() => navigate("..", {replace: true})}
                    object={{Name: "", Code: "", Active: true, Color: "", DefaultOperationID: null, workTask: null}}
                />
            </CardContent>
        </Card>
    </>;
}
